import {OrderType} from '../../types/order.type';
import {BillingSortType} from '../../types/billing.type';

export class GetBillingTvOwnerOperations {
  static readonly type = '[Billing tv-owner] Get billing operations';
}

export class SortBillingOperationsTvOwner {
  static readonly type = '[Billing tv-owner] Sort billing operations';

  constructor(public payload: {
    order: OrderType,
    sort: BillingSortType
  }) {
  }
}

export class SearchBillingOperationsTvOwner {
  static readonly type = '[Billing tv-owner] Search billing operations';

  constructor(public value: string) {
  }
}

export class SetBillingPageTvOwner {
  static readonly type = '[Billing tv-owner] Set page billing';

  constructor(public page: number) {
  }
}

export class GetTvOwnerBalance {
  static readonly type = '[Billing tv-owner] Get balance';
}
